"use strict";
const { fundingPotReference } = require('./budgetFiscal');
const { NATIONAL_REGION_CODE, NATIONAL_REGION_NAME, isFinanceRegion } = require('./regionScope');
const UNASSIGNED = 'UNASSIGNED';
const UNASSIGNED_LABEL = 'Unassigned pot';
const regionLabel = code => code === UNASSIGNED ? UNASSIGNED_LABEL : code === NATIONAL_REGION_CODE ? NATIONAL_REGION_NAME : null;

// Resolve the same selected pot as fiscal allocation. Residence is never a fallback.
function createFundingRegionResolver(pots = [], links = []) {
  const byId = new Map(pots.map(pot => [String(pot.id), pot]));
  const byCode = new Map();
  for (const pot of pots) if (pot.code) byCode.set(pot.code, byCode.has(pot.code) ? null : pot);
  const regions = new Map();
  for (const link of links) {
    const key = String(link.pot_id);
    if (!regions.has(key)) regions.set(key, new Set());
    if (link.region_code) regions.get(key).add(String(link.region_code).toUpperCase());
  }
  return row => {
    const reference = fundingPotReference(row);
    const pot = byId.get(reference) || byCode.get(reference) || null;
    const unresolved = issue => ({ pot, region: UNASSIGNED, issue });
    if (!pot) return unresolved('missing_budget_pot');
    if (String(pot.pot_type || '').toLowerCase().replace(/[_\s]+/g, ' ') !== 'funding stream') return unresolved('ineligible_budget_pot');
    const visited = new Set();
    let current = pot;
    while (current) {
      const id = String(current.id);
      if (visited.has(id)) return unresolved('ambiguous_budget_region');
      visited.add(id);
      const codes = [...(regions.get(id) || [])];
      if (codes.length > 1) return unresolved('ambiguous_budget_region');
      if (codes.length === 1) return isFinanceRegion(codes[0])
        ? { pot, region: codes[0], issue: null }
        : unresolved('invalid_budget_region');
      current = byId.get(String(current.parent_id));
    }
    return unresolved('missing_budget_region');
  };
}
module.exports = { createFundingRegionResolver, UNASSIGNED, UNASSIGNED_LABEL, regionLabel };
